import Hero from "../../designSystem/Hero";
import CalculatorsImag1 from "../../../assets/images/Calculators1.jpg";
import PensionShortfallCalculator from "../../calculators/PensionsShortfallCalculator";

const PensionShortfallPage = () => {
  return (
    <div>
      <Hero
        title="Pension Shortfall"
        subtitle=""
        backgroundImage={CalculatorsImag1}
      />
      <PensionShortfallCalculator />
      {/* <div className="landing-page">
            </div> */}
    </div>
  );
};

export default PensionShortfallPage;
